import axios, { AxiosResponse } from 'axios';
import { AppResponseType } from './types';

const apiJsonServer = axios.create({
  baseURL: 'http://localhost:4000',
  headers: {
    'Access-Control-Allow-Origin': 'true',
    'Content-Type': 'application/json',
  },
});

export const getAppList = (
  body: any,
): Promise<AxiosResponse<AppResponseType>> =>
  apiJsonServer.get('/applications', body);
